import { render } from "./consultingService.vue?vue&type=template&id=570ecfd3&scoped=true"
import script from "./consultingService.vue?vue&type=script&lang=js"
export * from "./consultingService.vue?vue&type=script&lang=js"

import "./consultingService.vue?vue&type=style&index=0&id=570ecfd3&scoped=true&lang=css"

import exportComponent from "E:\\项目\\潞安6s移动端\\H5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-570ecfd3"]])

export default __exports__